import Kevel, { KevelAdPlacementSlot, KevelContainerSelector } from '@clientWebModules/kevel';
import { KevelAdData } from '@clientWebServices/kevel.service';
import EasyfyModules from '@shared/easyfy.events/easyfy.eventhandler';
import { HayppFeatureNames } from '@clientShared/HayppFeatureNames';
import { Features } from '@webServices/features.service';
import { logCustomMessage } from '@shared/easyfy.logger';

let pendingPlacement: Promise<KevelAdData | null> | null = null;
let hasImpressed = false;

export function initKevelSearchSuggestionAd(container: HTMLElement): void {
  if (!container.matches(KevelContainerSelector.SearchSuggestionAd)) return;

  if (!Features.FeatureIsActive(HayppFeatureNames.Kevel)) {
    hideKevelSectionAndEmptySidebar(container);
    return;
  }

  const link = container.querySelector<HTMLElement>('[data-kevel-search-suggestion-ad-link]');
  if (!link) {
    hideKevelSectionAndEmptySidebar(container);
    return;
  }

  void fetchAndShow(container, link);
}

async function fetchAndShow(container: HTMLElement, link: HTMLElement): Promise<void> {
  let placement: KevelAdData | null;

  try {
    pendingPlacement ??= Kevel.Instance.fetchKevelAdPlacement(link, KevelAdPlacementSlot.SEARCH_SUGGESTION_AD_SLOT);
    placement = await pendingPlacement;
  } catch {
    logCustomMessage('Fetch kevel search suggestion ad failed', {
      action: 'fetchAndShow',
      message: 'Error fetching kevel search suggestion ad placement',
      data: JSON.stringify({ divName: link.dataset.kevelSearchSuggestionAdLink }),
    });

    hideKevelSectionAndEmptySidebar(container);
    return;
  }

  if (!container.isConnected) return;

  if (!placement) {
    hideKevelSectionAndEmptySidebar(container);
    return;
  }

  Kevel.Instance.applyKevelAdData(link, placement);
  container.classList.add('is-visible');

  if (!hasImpressed) {
    hasImpressed = true;
    void EasyfyModules.EasyfyEventHandler.TriggerElementImpression(link);
  }
}

function hideKevelSectionAndEmptySidebar(container: HTMLElement): void {
  const kevelSection = container.closest<HTMLElement>('.search-focusin__kevel');
  const sidebar = kevelSection?.closest<HTMLElement>('.search-focusin__kevel-and-articles');

  kevelSection?.remove();

  if (sidebar && sidebar.childElementCount === 0) {
    sidebar.remove();
  }
}
